import { ReactElement } from 'react';
import { DEFAULT_EC2_ROUTES } from '@localstack/constants';
import { AwsClientOverrides, getSchema } from '@localstack/services';
import { CreateEC2SecurityGroupRequest } from '@localstack/types';

import { RelatedResourcePicker } from '../../../form/RelatedResourcePicker';
import { MagicForm } from '../../magic/MagicForm';

export interface SecurityGroupFormProps {
  loading?: boolean;
  formId?: string;
  clientOverrides?: AwsClientOverrides;
  onSubmit: (data: CreateEC2SecurityGroupRequest) => unknown;
}

export const SecurityGroupForm = ({
  loading,
  formId,
  clientOverrides,
  onSubmit,
}: SecurityGroupFormProps): ReactElement => (
  <MagicForm
    schema={getSchema('EC2')}
    loading={loading}
    entry="CreateSecurityGroupRequest"
    formId={formId}
    fieldsOrder={['GroupName', 'Description', 'VpcId', 'TagSpecifications']}
    fieldConditions={{
      '^DryRun$': false,
    }}
    externalFields={{
      '^VpcId$': (control, fieldName, required) => (
        <RelatedResourcePicker
          control={control}
          client="EC2"
          method="describeVpcs"
          arrayKeyName="Vpcs"
          property="VpcId"
          fieldName={fieldName}
          entityName="VPC"
          required={required}
          clientOverrides={clientOverrides}
          creationRoute={DEFAULT_EC2_ROUTES.RESOURCES_EC2_VPC_CREATE}
        />
      ),
    }}
    onSubmit={(data: CreateEC2SecurityGroupRequest) => onSubmit(data)}
  />
);
